import React from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import CustomContainer from '../../components/CustomContainer';
import LegalDocumentTableConfig from './LegalDocumentTableConfig';
import LightButton from '../../components/button/LightButton';

const ReservationTablePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <CustomContainer title={'Dokumenty prawne'}>
        <FunctionalTableComponent
          shadow={false}
          title={'Lista dokumentów'}
          columns={LegalDocumentTableConfig}
          header={true}
          api={'legal-document'}
          removable={false}
          editable={false}
          trick="Dodanie nowego dokumentu automatycznie tworzy jego nową wersję. Edycja istniejącej wersji nie jest możliwa – możesz jedynie dodać kolejną."
          customCreate={() => {
            navigate('/legal-document');
          }}
          additionalButtons={function (row) {
            return (
              <LightButton
                onClick={() => {
                  navigate('/legal-document/' + row.id);
                }}
              >
                Szczegóły
              </LightButton>
            );
          }}
          width={12}
        />
      </CustomContainer>
    </>
  );
};

export default ReservationTablePage;
